import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { getInlineLoader } from "../Helpers";
import banner1 from '../assets/banner1.jpg';
import banner2 from '../assets/banner2.jpg';
import banner3 from '../assets/banner3.jpg';
import banner4 from '../assets/banner4.jpg';
import banner5 from '../assets/banner5.jpg';
import banner6 from '../assets/banner6.jpg';
import banner7 from '../assets/banner7.jpg';
import { 
  IoServer, IoConstruct, IoLaptopOutline, IoPeopleOutline, IoCall, 
  IoShieldCheckmarkOutline, IoSyncOutline, IoFlashOutline, IoSchoolOutline, 
  IoSearchOutline, IoLockClosedOutline, IoCardOutline, IoGlobeOutline 
} from "react-icons/io5";
import { GiCheckMark } from "react-icons/gi";
import logo from '../assets/logo.png';
import AOS from 'aos';
import 'aos/dist/aos.css';


export default function HomeBanner1(props) {

	const IconLegacy = () => (
	  <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#e2c000" strokeWidth="1.5">
		<path d="M12 2L2 7l10 5 10-5-10-5z" />
		<path d="M2 17l10 5 10-5" />
		<path d="M2 12l10 5 10-5" />
	  </svg>
	);
	
	const IconExpertise = () => (
	  <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#e2c000" strokeWidth="1.5">
		<circle cx="12" cy="12" r="10" fill="none" />
		<path d="M12 8v4l2 2" />
		<path d="M8 16h8" />
	  </svg>
	);
	
	const IconTrust = () => (
	  <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#e2c000" strokeWidth="1.5">
		<path d="M12 1v7" />
		<path d="M15 4l-3-3-3 3" />
		<path d="M5 12h14" />
		<path d="M8 12v8h8v-8" />
		<path d="M8 16h8" />
	  </svg>
	);
	

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ ready, setReady ] = useState(false);
	const [ bgIndex, setBgIndex ] = useState(0);
	const banners = [banner5, banner7, banner1, banner2, banner3, banner4, ];

	async function init() {
		setReady(false);
		// initializations...
		setReady(true);
	}
	

	useEffect(() => {
		init();
	}, []);
	
	useEffect(() => {
    AOS.init({
      duration: 1000,
      easing: 'ease-in-out',
      once: false,
    });
  }, []);

	// Background transition effect
	useEffect(() => {
		if (!ready) return;

		const interval = setInterval(() => {
			setBgIndex(prev => (prev + 1) % banners.length);
		}, 2500); // change every 5 seconds

		return () => clearInterval(interval);
	}, [ready]);

	if (ready) {
		return (
			<div className="MainBodySection">
				<div
					style={{
						width: "100%",
						height: "auto",
						position: "relative",
						overflow:"auto"
					}}
				>
					{banners.map((banner, i) => (
						<div
							key={i}
							style={{
								backgroundImage: `url(${banner})`,
								backgroundAttachment: "fixed",
								backgroundSize: "cover",
								backgroundPosition: "center",
								width: "100%",
								height: "100%",
								position: "absolute",
								top: 0,
								left: 0,
								transition: "opacity 1.5s ease-in-out",
								opacity: i === bgIndex ? 1 : 0,
							}}
						/>
					))}

					{/* gradient overlay */}
					<div
						style={{
							width: "100%",
							height: "100%",
							background: "rgba(0, 0, 0, 0.75)",
							position: "relative",
							zIndex: 1
						}}
					>
						<div className="container py-5">
							<div className="row g-4">
								<div className="col-md-12">
									<div className="main-section-title text-primary">
										OUR TEAM
									</div>
									<h6 className="text-light font-semi-bold text-center">
										Senior experts supported by younger collaborators and specialised consultants across disciplines.
									</h6>
								</div>
								<div 
									className="col-md-6 p-5 text-light"
								>
									<h1 className="font-bold">
										Staffing Capacity
									</h1>
									<h5 className="mt-3 font-light font-bold">
										The team consists of senior members of the group and a pool of outsourced consultants. 
										<br/><br/>
										This includes management specialists, knowledge management professionals, finance staff, administrative officers, and information technology experts.
										<br/><br/>
										The group works with a blend of long-standing experience, practical knowledge, and analytical precision.
										This strengthens its ability to meet client expectations and deliver solutions that align with sector needs.

									</h5>
								</div>
								
								{/* Right: "250+ Years" + 3 Icons */}
								<div className="col-md-6 d-flex flex-column gap-3 p-3">
									{/* Stat headline — above icons */}
									<div
										style={{
										background: "linear-gradient(135deg, #0a0a0a 0%, #1a1a1a 100%)",
										border: "1px solid #2d2d2d",
										padding: "16px 24px",
										display: "flex",
										alignItems: "center",
										justifyContent: "center",
										boxShadow: "0 4px 12px rgba(0,0,0,0.18)",
										}}
									>
										<span
										style={{
											fontSize: "32px",
											fontWeight: 800,
											color: "#e2c000",
											lineHeight: 1,
											textShadow: "0 1px 2px rgba(0,0,0,0.3)",
											minWidth: "96px",
										}}
										>
										250+
										</span>
										<span
										style={{
											fontSize: "18px",
											fontWeight: 600,
											color: "#f0f0f0",
											textTransform: "uppercase",
											letterSpacing: "0.5px",
										}}
										>
										Years of Experience
										</span>
									</div>

									{/* Icons row — unchanged from your spec */}
									<div
										className="d-flex flex-column flex-md-row gap-4"
										style={{ height: "100%" }}
									>
										{[
										{ Icon: IconLegacy, label: "Legacy" },
										{ Icon: IconExpertise, label: "Expertise" },
										{ Icon: IconTrust, label: "Trust" },
										].map((item, idx) => (
										<div
											key={idx}
											style={{
											flex: "1 1 auto",
											minWidth: "120px",
											background: "#0f0f0f",
											border: "1px solid #2d2d2d",
											padding: "20px 16px",
											display: "flex",
											flexDirection: "column",
											alignItems: "center",
											justifyContent: "center",
											gap: "12px",
											boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
											}}
										>
											<div
											style={{
												width: "48px",
												height: "48px",
												display: "flex",
												alignItems: "center",
												justifyContent: "center",
												background: "rgba(226, 192, 0, 0.08)",
												border: "1px solid rgba(226, 192, 0, 0.2)",
											}}
											>
											<item.Icon />
											</div>
											<span
											style={{
												fontSize: "14px",
												fontWeight: 600,
												color: "#f0f0f0",
												textAlign: "center",
												lineHeight: 1.4,
											}}
											>
											{item.label}
											</span>
										</div>
										))}
									</div>
								</div>
								
							</div>
							</div>
						</div>
					</div>

				</div>
		);
	} else {
		return (
			<div className="container mSupportLoading">
				{getInlineLoader()}
			</div>
		);
	}
}
